import { titleCase } from 'change-case'
import { useTheme } from '@opallabs/hooks'
import { WorkflowIcon } from '@opallabs/lapidary'
import type { NonPlaceholderStageTypes, StatusTypes } from '../../types'
import { styles } from './styles'

const formatStageTitle = (
  stageTitle?: string,
  stageType?: NonPlaceholderStageTypes
) => {
  if (!stageType) return ''
  if (stageTitle) return stageTitle
  if (stageType === 'circuit_breaker') return 'Pause'

  return `${titleCase(stageType)} Phase`
}

export type StatusTitleProps = {
  stageStatus?: 'approved' | 'denied' | 'pending'
  activeStageType?: NonPlaceholderStageTypes
  stageTitle?: string
  loading: boolean
  workflowStatus?: StatusTypes
}

export const StatusTitle: React.FC<StatusTitleProps> = ({
  stageStatus,
  activeStageType,
  stageTitle,
  loading,
  workflowStatus,
}) => {
  const theme = useTheme()
  const hasIcon =
    activeStageType === 'task' ||
    activeStageType === 'approval' ||
    activeStageType === 'circuit_breaker'

  if (loading)
    return <h6 css={styles.headingText({ theme, hasIcon: false })}>Loading…</h6>
  if (!workflowStatus)
    return (
      <h6 css={styles.headingText({ theme, hasIcon: false })}>
        Workflow Not Created
      </h6>
    )
  if (workflowStatus === 'inactive')
    return (
      <h6 css={styles.headingText({ theme, hasIcon: false })}>
        Workflow Not Started
      </h6>
    )
  if (workflowStatus === 'complete')
    return (
      <h6 css={styles.headingText({ theme, hasIcon: false })}>
        Workflow Complete
      </h6>
    )

  const approvalStatus = stageStatus
    ? (`approval-${stageStatus}` as const)
    : 'approval-pending'

  const iconSize = 18

  return (
    <span css={styles.headingContainer}>
      {activeStageType === 'task' && (
        <WorkflowIcon status="tasks-pending" size={iconSize} />
      )}
      {activeStageType === 'approval' && (
        <WorkflowIcon status={approvalStatus} size={iconSize} />
      )}
      {activeStageType === 'circuit_breaker' && (
        <WorkflowIcon status="paused" size={iconSize} />
      )}
      <h6 css={styles.headingText({ theme, hasIcon })}>
        {formatStageTitle(stageTitle, activeStageType)}
      </h6>
    </span>
  )
}
